// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__2SyYb","title":"ClientReferral_title__nr6Mi","itemText":"ClientReferral_itemText__16_Fl"};